import React, { useState } from 'react';
import data from '../../../utils/tabsData.json';
import MobileWatch from '../../../assets/mobile_watch.svg';
import WatchPage from '../../productDetail/WatchPage';
import './Collections.css';
import { useNavigate } from 'react-router-dom';

interface CollectionsProps {
  activeTab: string | null;
  activeSubTab: string | null;
  setShowBackground: (show: boolean) => void;
  setActiveTab: (tabId: string | null) => void;
  setActiveSubTabs: (subTabs: any[]) => void;
}

const Collections: React.FC<CollectionsProps> = ({
  activeTab,
  activeSubTab,
  setActiveTab,
  setActiveSubTabs,
  setShowBackground,
}) => {
  const [activeProduct, setActiveProduct] = useState<string | null>(null);
  const navigate = useNavigate();
  const activeTabData = data.tabs.find((tab) => tab.id === activeTab);
  const subTabData = activeTabData?.subtabs.find((subtab) => subtab.id === activeSubTab);

  if (!activeTabData || !subTabData) return null;

  const handleProductClick = (productId: string) => {
    setShowBackground(true);
    setActiveTab(null);
    navigate(`/watches/${productId}`)
  };

  return (
    <div className="collections-container">
      {subTabData.products && (
        <div className="product-design-boxes">
          {subTabData.products.map((product) => (
            <div key={product.id} className="product-box-container">
              <div
                className="product-box"
                key={product.id}
                onClick={() => handleProductClick(product.id)}
                style={{
                  backgroundImage: product.image ? `url(${MobileWatch})` : 'none',
                  backgroundColor: product.image ? 'transparent' : '#42424233',
                }}
              ></div>
              <p className="product-label">{product.label.en}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Collections;